export default __webpack_public_path__ + "static/media/Beard_2_C5.6625cff0.svg";